export default {
    'halls.loading': 'Loading',
    'halls.primary.title': 'Practice',
    'halls.middle.title': 'Expert',
    'halls.high.title': 'Elite',
    'halls.top.title': 'Master',
    'halls.level.describe': 'Hall Condition',
    'halls.coin.not': 'Insufficient coins',
    'halls.setting.title': 'Setting',
};